var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTruckTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/truck-tick"
  }, /*#__PURE__*/React.createElement("g", {
    id: "truck-tick"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3335 10.7366C14.5202 10.7366 14.6668 10.8833 14.6668 11.07V11.7366C14.6668 12.8433 13.7735 13.7366 12.6668 13.7366C12.6668 12.6366 11.7668 11.7366 10.6668 11.7366C9.56683 11.7366 8.66683 12.6366 8.66683 13.7366H7.3335C7.3335 12.6366 6.4335 11.7366 5.3335 11.7366C4.2335 11.7366 3.3335 12.6366 3.3335 13.7366C2.22683 13.7366 1.3335 12.8433 1.3335 11.7366V10.4033C1.3335 10.0366 1.6335 9.73663 2.00016 9.73663H8.3335C9.2535 9.73663 10.0002 8.98997 10.0002 8.06997V4.4033C10.0002 4.03663 10.3002 3.73663 10.6668 3.73663H11.2268C11.7068 3.73663 12.1468 3.99663 12.3868 4.40997L12.8135 5.15663C12.8735 5.2633 12.7935 5.4033 12.6668 5.4033C11.7468 5.4033 11.0002 6.14997 11.0002 7.06997V9.06997C11.0002 9.98997 11.7468 10.7366 12.6668 10.7366H14.3335Z",
    fill: "#B36CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M5.33333 15.07C6.06971 15.07 6.66667 14.473 6.66667 13.7367C6.66667 13.0003 6.06971 12.4033 5.33333 12.4033C4.59695 12.4033 4 13.0003 4 13.7367C4 14.473 4.59695 15.07 5.33333 15.07Z",
    fill: "#B36CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M10.6668 15.07C11.4032 15.07 12.0002 14.473 12.0002 13.7367C12.0002 13.0003 11.4032 12.4033 10.6668 12.4033C9.93045 12.4033 9.3335 13.0003 9.3335 13.7367C9.3335 14.473 9.93045 15.07 10.6668 15.07Z",
    fill: "#B36CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.6667 8.75665V9.73665H12.6667C12.3 9.73665 12 9.43665 12 9.06999V7.06999C12 6.70332 12.3 6.40332 12.6667 6.40332H13.5267L14.4933 8.09665C14.6067 8.29665 14.6667 8.52332 14.6667 8.75665Z",
    fill: "#B36CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.72016 1.73663H3.7935C2.4335 1.73663 1.3335 2.83663 1.3335 4.19663V8.44997C1.3335 8.81663 1.6335 9.11663 2.00016 9.11663H8.10016C8.78016 9.11663 9.3335 8.5633 9.3335 7.8833V2.34997C9.3335 2.00997 9.06016 1.73663 8.72016 1.73663ZM6.7135 5.11663L5.32016 6.4633C5.22016 6.55663 5.0935 6.6033 4.9735 6.6033C4.84683 6.6033 4.72016 6.55663 4.62683 6.4633L3.9535 5.8233C3.7535 5.62997 3.74683 5.30997 3.94016 5.10997C4.12683 4.90997 4.44683 4.90997 4.64683 5.09663L4.9735 5.40997L6.02016 4.39663C6.22016 4.2033 6.5335 4.20997 6.72683 4.40997C6.92016 4.60997 6.9135 4.9233 6.7135 5.11663Z",
    fill: "#B36CFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckTick);
export default __webpack_public_path__ + "static/media/truck-tick.a74537a8540fa72c81d30f1acc824106.svg";
export { ForwardRef as ReactComponent };